<div class="stops-timeline-container" *ngIf="stops && stops.length > 0">
  <div class="stops-header">
    <span class="stops-count">{{ stops.length }} Stop{{ stops.length > 1 ? 's' : '' }}</span>
  </div>

  <div class="stops-list">
    <div class="stop-item" *ngFor="let stop of displayedStops; let i = index; let isLast = last">
      <div class="stop-timeline">
        <div class="stop-number">{{ getStopNumber(i) }}</div>
        <div class="timeline-line" *ngIf="!isLast && (isExpanded || i === 0)"></div>
      </div>

      <div class="stop-content">
        <div class="stop-info">
          <div class="stop-location">{{ stop.location }}</div>
          <div class="stop-time">Planned: {{ getPlannedTime(stop.plannedStopTime) }}</div>
        </div>
        <div class="stop-eta" 
             *ngIf="getETA(stop.actualStopTime, stop.plannedStopTime)"
             [style.color]="getETA(stop.actualStopTime, stop.plannedStopTime)!.color">
          {{ getETA(stop.actualStopTime, stop.plannedStopTime)!.text }}
        </div>
      </div>

      <!-- Expand/Collapse Button (shown between first and last stop when collapsed) -->
      <div class="expand-button-container" *ngIf="shouldShowExpandButton() && i === 0 && !isExpanded">
        <div class="expand-button" (click)="toggleExpand()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7 10L12 15L17 10" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>{{ hiddenStopsCount }} more stop{{ hiddenStopsCount > 1 ? 's' : '' }}</span>
        </div>
      </div>
    </div>

    <!-- Collapse Button (shown at the end when expanded) -->
    <div class="collapse-button-container" *ngIf="shouldShowExpandButton() && isExpanded">
      <div class="collapse-button" (click)="toggleExpand()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M7 14L12 9L17 14" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Show less</span>
      </div>
    </div>
  </div>
</div>

<div class="no-stops" *ngIf="!stops || stops.length === 0">
  <p>No stops available</p>
</div>
